export default "__VITE_ASSET__ccda48fe__"